<template>
  <div id="app">
    <router-view/>
    <notifications group="foo" position="bottom right" />
  </div>
</template>

<style src="./style.scss" lang="scss"></style>

<script>
export default {
  name: 'app',
  metaInfo: {
    title: 'Index',
    titleTemplate: '%s - Admin Panel'
  },
  methods: {
    updateConnectionStatus() {
      this.$notify({
        group: 'foo',
        title: navigator.onLine ? 'Przywrócono połączenie z internetem' : 'Utracono połączenie z internetem',
        text: navigator.onLine ? 'Możesz już normalnie korzystać z panelu' : 'Zanim zapiszesz jakieś zmiany proszę sprawdź połączenie z internetem',
        type: navigator.onLine ? 'success' : 'error',
      });
    }   
  },
  mounted () {
    window.addEventListener('online', this.updateConnectionStatus)
    window.addEventListener('offline', this.updateConnectionStatus)    
  },
  beforeDestroy () {
    window.removeEventListener('online', this.updateConnectionStatus)
    window.removeEventListener('offline', this.updateConnectionStatus) 
  },
  updated () {
    // Remove loading state
    setTimeout(() => document.body.classList.remove('app-loading'), 1)
  }
}
</script>
